require('amplitude-js')

import amplitude from 'amplitude-js';

const amplitudClient = amplitude.getInstance()
amplitudClient.init("5f5a0f32055a2213b344bf0d1e70a01d");

amplitudClient.setDomain('gaussonline.com')
if(window.__USER_EMAIL) {
    amplitudClient.setUserId(window.__USER_EMAIL)
}

// handle utm

export default amplitudClient
